import statisticsCSS from "src/app/modules/admin/components/statistics/Statistics.module.css";

export const STATISTICS_TABS: {
  PARTNERS: string;
  SYSTEMS: string;
  BRANDS: string;
  REGION_PARTNERS: string;
  REGION_SYSTEMS: string;
  TARGET_GROUP_PROJECTS: string;
  TARGET_GROUP_USERS: string;
  TARGET_GROUP_SYSTEMS: string;
} = Object.freeze({
  PARTNERS: "partners",
  SYSTEMS: "systems",
  BRANDS: "brands",
  REGION_PARTNERS: "regionPartners",
  REGION_SYSTEMS: "regionSystems",
  TARGET_GROUP_PROJECTS: "targetGroupProjects",
  TARGET_GROUP_USERS: "targetGroupUsers",
  TARGET_GROUP_SYSTEMS: "targetGroupSystems",
});

const getOrCreateTooltip = (chart: any, name: string) => {
  let tooltipEl = document.getElementById(name);

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = name;
    tooltipEl.classList.add(statisticsCSS.tooltipContainer);

    let tooltipUl = document.createElement("ul");
    tooltipUl.classList.add(statisticsCSS.tooltipList);

    tooltipEl.appendChild(tooltipUl);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }
  return tooltipEl;
};

export const generateTitleTooltip = (context: any, name: string, labels: any, inputData: any, positionLeftPadding: number) => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart, name);

  // Set opacity on mouse move
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  // Set content
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map((b: any) => b.lines);

    const tooltipTitleLi = document.createElement("li");
    const tooltipCountLi = document.createElement("li");

    titleLines.forEach(function (title: string) {
      const labelIndex = labels.indexOf(title);
      const tooltipSpan = document.createElement("span");
      tooltipSpan.classList.add(statisticsCSS.tooltipTitle);
      tooltipTitleLi.appendChild(tooltipSpan);
      const tooltipTitle = document.createTextNode(inputData[labelIndex].name);
      tooltipSpan.appendChild(tooltipTitle);
    });

    bodyLines.forEach(function (body: string, i: number) {
      const countTextSpan = document.createElement("span");
      const countValue = document.createTextNode(body);
      const countText = document.createTextNode(" upita");

      countTextSpan.classList.add(statisticsCSS.tooltipHighlight);
      countTextSpan.appendChild(countValue);

      tooltipCountLi.appendChild(countTextSpan);
      tooltipCountLi.appendChild(countText);
    });

    const tooltipUl = tooltipEl.querySelector("ul");
    while (tooltipUl!.firstChild) {
      tooltipUl?.firstChild.remove();
    }

    tooltipUl!.appendChild(tooltipTitleLi);
    tooltipUl!.appendChild(tooltipCountLi);
  }

  // Set position
  tooltipEl.classList.remove("above", "below", "no-transform");
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign);
  } else {
    tooltipEl.classList.add("no-transform");
  }

  // Set display, position, and styles for font
  tooltipEl.style.opacity = "1";
  tooltipEl.style.left = window.pageXOffset + tooltip.caretX + positionLeftPadding + "px";
  tooltipEl.style.top = tooltip.caretY + "px";
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.padding + "px " + tooltip.options.padding + "px";
  tooltipEl.style.pointerEvents = "none";
};

export const generateDetailsTooltip = (context: any, name: string, labels: any, inputData: any, positionLeftPadding: number) => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart, name);

  // Set opacity on mouse move
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  // Set content
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map((b: any) => b.lines);

    const tooltipTitleLi = document.createElement("li");
    const tooltipAddressLi = document.createElement("li");
    const tooltipCountLi = document.createElement("li");

    titleLines.forEach(function (title: string) {
      const labelIndex = labels.indexOf(title);
      const tooltipSpan = document.createElement("span");
      tooltipSpan.classList.add(statisticsCSS.tooltipTitle);
      tooltipTitleLi.appendChild(tooltipSpan);
      const tooltipTitle = document.createTextNode(inputData[labelIndex].name);
      tooltipSpan.appendChild(tooltipTitle);

      const tooltipAddress = document.createTextNode(inputData[labelIndex].address);
      tooltipAddressLi.appendChild(tooltipAddress);
    });

    bodyLines.forEach(function (body: string, i: number) {
      const countTextSpan = document.createElement("span");
      const countValue = document.createTextNode(body);
      const countText = document.createTextNode(" upita");

      countTextSpan.classList.add(statisticsCSS.tooltipHighlight);
      countTextSpan.appendChild(countValue);

      tooltipCountLi.appendChild(countTextSpan);
      tooltipCountLi.appendChild(countText);
    });

    const tooltipUl = tooltipEl.querySelector("ul");
    while (tooltipUl!.firstChild) {
      tooltipUl?.firstChild.remove();
    }

    tooltipUl!.appendChild(tooltipTitleLi);
    tooltipUl!.appendChild(tooltipAddressLi);
    tooltipUl!.appendChild(tooltipCountLi);
  }

  // Set position
  tooltipEl.classList.remove("above", "below", "no-transform");
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign);
  } else {
    tooltipEl.classList.add("no-transform");
  }

  // Set display, position, and styles for font
  tooltipEl.style.opacity = "1";
  tooltipEl.style.position = "absolute";
  tooltipEl.style.left = window.pageXOffset + tooltip.caretX + positionLeftPadding + "px";
  tooltipEl.style.top = tooltip.caretY + "px";

  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.padding + "px " + tooltip.options.padding + "px";
  tooltipEl.style.pointerEvents = "none";
};

export const generateGroupedTooltip = (context: any, name: string, colors: any, inputData: any, positionLeftPadding: number) => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart, name);

  // Set opacity on mouse move
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  // Set content
  if (tooltip.body) {
    const input = inputData[tooltip.dataPoints[0].dataIndex];

    const tooltipTitleLi = document.createElement("li");
    let tooltipCountLis: any[] = [];

    const tooltipSpan = document.createElement("span");
    tooltipSpan.classList.add(statisticsCSS.tooltipTitle);
    tooltipTitleLi.appendChild(tooltipSpan);
    const tooltipTitle = document.createTextNode(input.name);
    tooltipSpan.appendChild(tooltipTitle);
    let totalCount = 0;

    input.children.forEach(function (item: any, i: number) {
      const tooltipCountLi = document.createElement("li");
      const itemRect = document.createElement("div");
      const itemNameSpan = document.createElement("span");
      const countValueSpan = document.createElement("span");
      const countStakeSpan = document.createElement("span");
      const countTextSpan = document.createElement("span");
      const itemName = document.createTextNode(item.name);
      const countValue = document.createTextNode(item.projectsCount);
      const countStake = document.createTextNode(item.projectsStake);
      const countText = document.createTextNode(" upita");
      const open = document.createTextNode(" (");
      const close = document.createTextNode("%)");

      itemRect.classList.add(statisticsCSS.tooltipRectangle);
      itemRect.style.backgroundColor = colors[i];
      countValueSpan.classList.add(statisticsCSS.tooltipBold);
      countValueSpan.appendChild(countValue);

      countStakeSpan.classList.add(statisticsCSS.tooltipBold);
      countStakeSpan.appendChild(countStake);

      itemNameSpan.appendChild(itemName);
      countTextSpan.appendChild(countText);

      tooltipCountLi.classList.add(statisticsCSS.tooltipListItem);
      tooltipCountLi.appendChild(itemRect);
      tooltipCountLi.appendChild(document.createTextNode("\u00A0"));
      tooltipCountLi.appendChild(itemNameSpan);
      tooltipCountLi.appendChild(document.createTextNode("\u00A0\u00A0"));
      tooltipCountLi.appendChild(countValueSpan);
      tooltipCountLi.appendChild(document.createTextNode("\u00A0"));
      tooltipCountLi.appendChild(countTextSpan);
      tooltipCountLi.appendChild(document.createTextNode("\u00A0"));
      tooltipCountLi.appendChild(open);
      tooltipCountLi.appendChild(countStakeSpan);
      tooltipCountLi.appendChild(close);
      tooltipCountLis.push(tooltipCountLi);

      totalCount += item.projectsCount;
    });

    const tooltipUl = tooltipEl.querySelector("ul");
    while (tooltipUl!.firstChild) {
      tooltipUl?.firstChild.remove();
    }

    tooltipUl!.appendChild(tooltipTitleLi);

    tooltipCountLis.forEach(function (tooltipCount: any, i: number) {
      tooltipUl!.appendChild(tooltipCount);
    });

    const tooltipCountLi = document.createElement("li");
    const totalValueSpan = document.createElement("span");
    const totalName = document.createTextNode("sveukupno ");
    const totalValue = document.createTextNode(totalCount.toString());
    const totalText = document.createTextNode(" upita");
    totalValueSpan.classList.add(statisticsCSS.tooltipBold);
    totalValueSpan.appendChild(totalValue);
    tooltipCountLi.appendChild(totalName);
    tooltipCountLi.appendChild(totalValueSpan);
    tooltipCountLi.appendChild(totalText);

    tooltipUl!.appendChild(tooltipCountLi);
  }

  // Set position
  tooltipEl.classList.remove("above", "below", "no-transform");
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign);
  } else {
    tooltipEl.classList.add("no-transform");
  }

  // Set display, position, and styles for font
  tooltipEl.style.opacity = "1";
  tooltipEl.style.left = tooltip.caretX + positionLeftPadding + "px";
  tooltipEl.style.top = tooltip.caretY + "px";
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.padding + "px " + tooltip.options.padding + "px";
  tooltipEl.style.pointerEvents = "none";
};
